// 首页查询模块
import Axios from './config'

//报表列表
const getReportlist = (params) => {
  return Axios({
    method: 'get',
    url: `/web/report/getReportList`,
    params: params
  })
}
//报表期别列表
const getpdlist = (params) => {
  return Axios({
    method: 'get',
    url: `/web/report/getReportTimeList`,
    params: params
  })
}
//报表详情
const getReport = (params) => {
  return Axios({
    method: 'get',
    url: `/gov/getReportInfo`,
    params: params
  })
}


export{
  getReportlist,getpdlist,getReport
}


// WEBPACK FOOTER //
// ./src/api/dataReport.js